interface EmptyStateProps {
  message?: string;
  hint?: string;
  icon?: 'search' | 'data' | 'error' | 'inbox';
}

const ICONS: Record<string, string> = {
  search:
    '<circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/>',
  data:
    '<ellipse cx="12" cy="5" rx="9" ry="3"/><path d="M3 5v14a9 3 0 0 0 18 0V5"/><path d="M3 12a9 3 0 0 0 18 0"/>',
  error:
    '<circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>',
  inbox:
    '<polyline points="22 12 16 12 14 15 10 15 8 12 2 12"/><path d="M5.45 5.11 2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"/>',
};

export function EmptyState({ message = 'No data found', hint, icon = 'inbox' }: EmptyStateProps) {
  return (
    <div class="empty-state-box">
      <svg
        class="empty-state-icon"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
        dangerouslySetInnerHTML={{ __html: ICONS[icon] ?? ICONS.inbox }}
      />
      <p>{message}</p>
      {hint && <p class="empty-state-hint">{hint}</p>}
    </div>
  );
}
